import { render } from "./MsTh.vue?vue&type=template&id=656f741e"
import script from "./MsTh.vue?vue&type=script&lang=js"
export * from "./MsTh.vue?vue&type=script&lang=js"

import "./MsTh.vue?vue&type=style&index=0&id=656f741e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__